import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { customServiceApi, accompanyServiceApi } from '../../api/customService';

// 定制服务的异步 Thunks
export const fetchCustomServiceList = createAsyncThunk(
  'customService/fetchList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await customServiceApi.getCustomServiceList(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createCustomService = createAsyncThunk(
  'customService/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await customServiceApi.createCustomService(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCustomService = createAsyncThunk(
  'customService/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await customServiceApi.updateCustomService(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCustomService = createAsyncThunk(
  'customService/delete',
  async (id, { rejectWithValue }) => {
    try {
      await customServiceApi.deleteCustomService(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// 陪逛服务的异步 Thunks
export const fetchAccompanyServiceList = createAsyncThunk(
  'accompanyService/fetchList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await accompanyServiceApi.getAccompanyServiceList(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createAccompanyService = createAsyncThunk(
  'accompanyService/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await accompanyServiceApi.createAccompanyService(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAccompanyService = createAsyncThunk(
  'accompanyService/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await accompanyServiceApi.updateAccompanyService(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteAccompanyService = createAsyncThunk(
  'accompanyService/delete',
  async (id, { rejectWithValue }) => {
    try {
      await accompanyServiceApi.deleteAccompanyService(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// 定制服务 Slice
const customServiceSlice = createSlice({
  name: 'customService',
  initialState: {
    list: [],
    loading: false,
    error: null,
    pagination: {
      total: 0,
      current: 1,
      pageSize: 10
    }
  },
  reducers: {
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomServiceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomServiceList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.pagination.total = action.payload.total;
      })
      .addCase(fetchCustomServiceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCustomService.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(updateCustomService.fulfilled, (state, action) => {
        const index = state.list.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(deleteCustomService.fulfilled, (state, action) => {
        state.list = state.list.filter(item => item.id !== action.payload);
      });
  }
});

// 陪逛服务 Slice
const accompanyServiceSlice = createSlice({
  name: 'accompanyService',
  initialState: {
    list: [],
    loading: false,
    error: null,
    pagination: {
      total: 0,
      current: 1,
      pageSize: 10
    }
  },
  reducers: {
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccompanyServiceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccompanyServiceList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.pagination.total = action.payload.total;
      })
      .addCase(fetchAccompanyServiceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createAccompanyService.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(updateAccompanyService.fulfilled, (state, action) => {
        const index = state.list.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(deleteAccompanyService.fulfilled, (state, action) => {
        state.list = state.list.filter(item => item.id !== action.payload);
      });
  }
});

export const { setPagination: setCustomServicePagination } = customServiceSlice.actions;
export const { setPagination: setAccompanyServicePagination } = accompanyServiceSlice.actions;

export const customServiceReducer = customServiceSlice.reducer;
export const accompanyServiceReducer = accompanyServiceSlice.reducer; 